import styled, { css } from 'styled-components';
import { SkeletonProps } from './skeleton.types';

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  > * {
    overflow: hidden;
    position: relative;
  }
`;

export const LoadingWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const Skeleton = styled.div<{
  animate: SkeletonProps['animate'];
  animationDuration: SkeletonProps['animationDuration'];
}>(
  ({ theme: { color }, animate, animationDuration }) => css`
    background: ${`linear-gradient(-45deg, ${color.ui5}, ${color.ui6})`};
    animation: ${animate ? `gradient ${animationDuration}ms ease infinite` : ''};
    background-size: 400% 400%;
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    flex-grow: 1;

    @keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
    }
  `,
);
